module.exports = "/packs/images/svg/accessibility/disabled_toilets~e605c447cfabc3f0b8bd11c8af2d3d70.svg";